export default __webpack_public_path__ + "static/media/dimos_agriniou.089de0be.png";